export default "__VITE_ASSET__BfNJ1iea__"